module.exports = __webpack_public_path__ + "img/theme.67cef4b9.png";